import React from "react";

const RadioGroup = ({ options,handleDcthreshold,dcthreshold }) => {
  return (
    <div className="row">
      <div className="row w-100">
        {options.map((option, key) => (
          <div className="col-md-4" key={key}>
            <div className={`col-md-12  ${option.value === dcthreshold?.type?"border-green-radius-5px":"border-radius-5px"}`}>
              <div className="row align-items-center">
                <div className="col-md-2">
                  <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                    <div className="custom-control custom-radio">
                      <input
                         key={key}
                        type="radio"
                        id="customRadio1"
                        name="type"
                        className="custom-control-input islandableRadio asCompatible"
                        value={option.value}
                        checked={option.value === dcthreshold?.type?true:false}
                        onChange={handleDcthreshold}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customRadio1"
                      >
                        &zwnj;
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-md-10 p-2">
                  <div className="row">
                    <div className="col-md-12 mt-1">
                      <span className="bold">{option.value}</span>
                    </div>
                    <div className="col-md-12 mt-1">
                      <span>{option.description}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
